import React, { PureComponent } from 'react';

import { Dropdown, Image } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ReactTableFilterDropdown.css';
const cx = classNames.bind(styles);

class ReactTableFilterDropdown extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { isMulti, listItem, filter, handleChangeFilter, column } = this.props;

    return (
      <div className={cx('react-table-filter-drondown')}>
        <div className={cx('filter-arrow-area')}>
          <Image
            className={cx('dropdown-image')}
            src={'/img/table/selectbox_file_arrow' + (filter[column] ? '_active' : '') + '.png'}
          />
        </div>
        <Dropdown text=" " scrolling icon={null} className={cx('filter-drondown', { isMulti })}>
          <Dropdown.Menu>
            {listItem.map((data, index) => {
              let selected = data.value === filter[column] ? true : false;
              let itemIcon = null;
              if (isMulti) {
                selected = Number(data.value) & Number(filter[column]) ? true : false;
                itemIcon = selected ? 'checkmark box' : 'square outline';
              }

              return (
                <Dropdown.Item
                  key={index}
                  className={cx({ selected })}
                  icon={itemIcon}
                  text={data.text}
                  value={data.value}
                  onClick={(e, props) => {
                    e.stopPropagation();
                    handleChangeFilter(column, data.value, isMulti);
                  }}
                />
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }
}

export default ReactTableFilterDropdown;



// WEBPACK FOOTER //
// ./src/script/components/common/ReactTableFilterDropdown.js